import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import millimeterMask from "Components/Input/components/millimeterMask";
import * as R from "ramda";
import { GetAllRokub, InsertRokubData, changeRokubSearch } from "Stores/actions";
import { toggleNAluminiumUpvc } from "Constants/Constants";
import { read } from "Helpers/LocalStorage";
import {DialogActions} from "@material-ui/core";
import showNotify from "Helpers/Notify";
import { useTranslation } from 'react-i18next';
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";

function InsertRokub() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [checkValid, setCheckValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const { rokubDataPagination } = useSelector((state) => ({
    rokubDataPagination: state.rokub.rokubDataPagination,
  }));
  const [controls, setControls] = useSetState({
    struct: {
      type: "toggle",
      arrayItems: toggleNAluminiumUpvc,
      value: toggleNAluminiumUpvc[0],
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
    },
    nameRokub: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
    },
    sizeRokub: {
      type: "millimeter",
      value: "",
      validation: {
        required: true,
        isNumeric: true,
        min: 9,
        minLength: 1,
        maxLength: 3,
      },
      col: {
        sm: 12,
        xs: 12,
      },
    },
    priceRokub: {
      type: "price",
      value: "",
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const handleDialog = (isOnClose = false) => {
    if(isOnClose) onClear();
    setOpenDialog(!openDialog);
  }

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
  };

  const onFinish = async (e) => {
    e.preventDefault();
    const { nameRokub, priceRokub, sizeRokub, struct } = controls;
    if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
    ) {
      const IdStruct = struct.value.value === "upvc" ? 1 : 2;
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Price: +priceRokub.value,
          Name: nameRokub.value,
          Size: +sizeRokub.value,
          IdStruct: IdStruct,
        };
        await dispatch(InsertRokubData(data));
        dispatch(changeRokubSearch({ Name: "" }));
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: rokubDataPagination.Limit,
          Page: 1,
        };
        await dispatch(GetAllRokub(params));

        handleDialog();
        onClear();
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t('correctFormDataRequired'),
          customClass: "error",
        });
      }
    } else {
      setCheckValid(true);
    }
  };

  const onEnter = async () => {
    onClear();
  };

  const onClear = () => {
    setCheckValid(false);
    setFormValid({nameRokub: false , priceRokub: false , sizeRokub : false});
    setControls({ nameRokub: { value: "" } });
    setControls({ struct: { value: toggleNAluminiumUpvc[0] } });
    setControls({ sizeRokub: { value: "" } });
    setControls({ priceRokub: { value: "" } });
  };
  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"newFlashing"}/>}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={() => handleDialog(true)}
        onEnter={onEnter}
        fullWidth
        maxWidth="xs"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"addNewFlashing"}/>} </p>
          </div>
          <DialogContent>
            <Grid container spacing={2} className="d-flex mb-2">
              {
                Object.keys(controls).filter(key => controls[key].type === "toggle").map((key, index) => {
                  return (
                    <Grid item key={key + index} className="flex-grow-1">
                      <MuiRadioGroup
                        name={key}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        items={controls[key].arrayItems}
                        onChange={onChangeToggle}
                        translate={true}
                        className="horizontalRadio"
                      />
                    </Grid>
                  );
                })
              }
            </Grid>
            <Grid container spacing={2} className="d-flex">
              {
                Object.keys(controls).filter(key => controls[key].type !== "toggle").map((key, index) => {
                  return (
                    <Grid item key={key + index} className="flex-grow-1">
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        placeholder={t(key === 'sizeRokub' ? 'size' : key)}
                        validation={controls[key].validation}
                        checkValid={checkValid}
                        label={<Translator id={key === 'sizeRokub' ? 'size' : key} />}
                        type={controls[key].type}
                        inputComponent={controls[key].type === "millimeter" ? millimeterMask : ''}
                        endIcon={controls[key].type === "price" ? <Translator id='moneyUnit' /> : controls[key].type === "millimeter" ? <Translator id='millimeter' /> : ''}
                        minLength={controls[key]?.validation?.minLength}
                        maxlength={controls[key]?.validation?.maxLength}
                      />
                    </Grid>
                  );
                })
              }
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default InsertRokub;
